import { FC } from 'react';
import format from '../../utils/format';
import { ButtonProps } from './Button.types';
import styles from './button.module.scss';
import Typography from '../Typography/Typography';

const Button: FC<ButtonProps> = ({
  clickHandling,
  colorVariant = 'ocean',
  typeVariant = 'primary',
  upperCaseLabel = true,
  disabled = false,
  label,
  loading = false,
  errorMsg,
  formID,
}) => {
  const isSubmit = clickHandling === 'submit';
  const isURL = typeof clickHandling === 'object' && clickHandling.url;
  const isClickHandler = typeof clickHandling === 'function';

  const child = isURL ? (
    <a
      href={clickHandling.url}
      target={clickHandling.newTab ? '_blank' : undefined}
      rel="noopener noreferrer"
    >
      {/* TODO:#2204 remove upper casing from the button */}
      {upperCaseLabel ? format.toUpperCase(label) : label}
    </a>
  ) : upperCaseLabel ? (
    format.toUpperCase(label)
  ) : (
    label
  );

  const renderChildren = (): JSX.Element => (
    <>
      {child}

      {loading && (
        <div className={styles.loader}>
          <span className={styles.loaderDot} />
          <span className={styles.loaderDot} />
          <span className={styles.loaderDot} />
        </div>
      )}
    </>
  );

  return (
    <div className={styles.container}>
      <button
        className={`${styles.button} ${styles[colorVariant]} ${styles[typeVariant]} ${
          loading ? styles.loading : ''
        }`}
        disabled={disabled || loading}
        aria-busy={loading}
        onClick={isClickHandler ? clickHandling : undefined}
        type={isSubmit ? 'submit' : 'button'}
        form={formID}
      >
        {renderChildren()}
      </button>
      <div className={styles.errorWrapper}>
        <Typography variant="error" align="center" format="sentence">
          {errorMsg}
        </Typography>
      </div>
    </div>
  );
};

export default Button;
